import { render, staticRenderFns } from "./AddGooglePoint.vue?vue&type=template&id=315e533d&scoped=true"
import script from "./AddGooglePoint.vue?vue&type=script&lang=js"
export * from "./AddGooglePoint.vue?vue&type=script&lang=js"
import style0 from "./AddGooglePoint.vue?vue&type=style&index=0&id=315e533d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315e533d",
  null
  
)

export default component.exports